import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { BioStatItem } from './BioStatItem';

/**
 * @param root0
 * @param root0.data
 * @returns {JSX.Element} Bio Stats section.
 */
export const BioStats = ({ data }) => {
    const dispatch = useDispatch();

    const playerId = new URLSearchParams(location.search).get('playerId');
    const playerStats = useSelector((state) =>
        PULSE.app.redux.selectors.statsplayerprofile.item(state, playerId)
    );
    const dateFormat = 'DD MMM YYYY';

    const [bioStatsList, setBioStatsList] = useState([]);

    useEffect(() => {
        // Initialise the player profile in the redux store
        dispatch(
            PULSE.app.redux.actions.statsplayerprofile.ADD_PLAYER_PROFILE.request(
                data.seasonId,
                playerId
            )
        );
    }, []);

    useEffect(() => {
        if (playerStats?.careerTotals) {
            setBioStatsList([
                {
                    name: PULSE.I18N.lookup('label.stat.totalGames'),
                    value: playerStats.careerTotals.matchesPlayed
                },
                {
                    name: PULSE.I18N.lookup('label.stat.debut'),
                    value: playerStats.playerDetails.debutYear
                },
                {
                    name: PULSE.I18N.lookup('label.stat.height'),
                    value: playerStats.playerDetails.heightCm + 'cm'
                },
                {
                    name: PULSE.I18N.lookup('label.stat.weight'),
                    value: playerStats.playerDetails.weightKg + 'kg'
                },
                {
                    name: PULSE.I18N.lookup('label.stat.dateOfBirth'),
                    value: PULSE.app.common.date.momentCustomFormat(
                        playerStats.playerDetails.dateOfBirth,
                        dateFormat,
                        true
                    )
                }
            ]);
        }
    }, [playerStats?.careerTotals]);

    return (
        <div className="pp-bio-stats">
            {bioStatsList.map((stat, index) => (
                <BioStatItem stat={stat} key={index}></BioStatItem>
            ))}
        </div>
    );
};

BioStats.propTypes = {
    data: PropTypes.object.isRequired
};
